export const NOTIFICATIONS = {
  success: "success",
  error: "error",
  info: "info",
  warning: "warning",
  report: "report",
};
